<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Ốc Ta
                  <!-- <span>completed with examples</span> -->
                </h1>
                <p class="lead  text-white">
                  Là doanh nghiệp cung cấp dịch vụ viễn thông quy mô lớn nhất
                  Việt Nam. Nhà phân phối hàng đầu cung cấp các sản phẩm và dịch
                  vụ viễn thông, game của tất cả các đơn vị viễn thông và nhà
                  phát hành game trên toàn quốc.
                </p>
                <div class="btn-wrapper">
                  <a href="#"
                    ><img
                      src="../../public/img/brand/octa-googleplay.png"
                      width="135"
                      style=" border-radius: 7px"
                  /></a>
                  <a href="#"
                    ><img
                      src="../../public/img/brand/octa-app-store.png"
                      width="135"
                      style=" border-radius: 7px; margin-left: 15px;"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="section2-func">
                    <icon
                      name="ni ni-check-bold"
                      size="lg"
                      type="primary"
                      rounded
                      class="mb-4 icon_home_page"
                    >
                    </icon>
                    <h6 class="text-primary text-uppercase title_home_page">
                      Dịch vụ
                    </h6>
                  </div>
                  <p class="description mt-3">
                    Dịch vụ cung cấp thẻ cào điện thoại của tất cả các nhà mạng.
                  </p>
                  <!--
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    -->
                  <base-button tag="a" href="#" type="primary" class="mt-4">
                    Chi tiết
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="section2-func">
                    <icon
                      name="ni ni-istanbul"
                      size="lg"
                      type="success"
                      rounded
                      class="mb-4"
                    >
                    </icon>
                    <h6 class="text-success text-uppercase title_home_page">
                      Ứng dụng
                    </h6>
                  </div>
                  <p class="description mt-3">
                    Cung cấp các dịch vụ thuê bao di động cho khách hàng.
                  </p>
                  <!--
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div>
                                    -->
                  <base-button tag="a" href="#" type="success" class="mt-4">
                    Chi tiết
                  </base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <div class="section2-func">
                    <icon
                      name="ni ni-planet"
                      size="lg"
                      type="warning"
                      rounded
                      class="mb-4"
                    >
                    </icon>
                    <h6 class="text-warning text-uppercase title_home_page">
                      Trợ giúp
                    </h6>
                  </div>
                  <p class="description mt-3">
                    Hướng dẫn sử dụng và Câu hỏi thường gặp.
                  </p>
                  <!--
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div>
                                    -->
                  <base-button tag="a" href="#" type="warning" class="mt-4">
                    Chi tiết
                  </base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <img
              src="../../public/img/brand/dichvusanpham.jpg"
              class="img-fluid"
            />
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <div class="d-flex align-items-center">
                <icon
                  name="ni ni-satisfied"
                  size="lg"
                  type="success"
                  rounded
                  class="mb-4 icon_home_page"
                ></icon>
                <h3 class="text-success text-uppercase title_home_page">
                  Sản phẩm và dịch vụ
                </h3>
              </div>
              <!--
                            <h6>Thẻ cào điện thoại</h6>
                            <p>Là dịch vụ cung cấp thẻ cào điện thoại của tất cả các nhà mạng </p>
                            <h6>Sim điện thoại</h6>
                            <p>Cung cấp các dịch vụ thuê bao di động cho khách hàng từ cá nhân tới các tổ chức, doanh nghiệp.</p>
                            <h6>Mã thẻ điện thoại</h6>
                            <p>Là dịch vụ bán các loại mã thẻ điện thoại trả trước thông qua hệ thống điện tử.</p>
                            -->
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-settings-gear-65"
                    ></badge>
                    <h6 class="mb-0">Thẻ cào điện thoại</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-html5"
                    ></badge>
                    <h6 class="mb-0">Sim điện thoại</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-satisfied"
                    ></badge>
                    <h6 class="mb-0">Mã thẻ điện thoại</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-active-40"
                    ></badge>
                    <h6 class="mb-0">Thanh toán vé máy bay, điện , nước</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-satisfied"
                    ></badge>
                    <h6 class="mb-0">Mã thẻ game, dịch vụ truyền hình</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge
                      type="success"
                      circle
                      class="mr-3"
                      icon="ni ni-html5"
                    ></badge>
                    <h6 class="mb-0">Tư vấn đầu tư tài chính</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img
                v-lazy="'img/theme/lich-su-hinh-thanh.jpg'"
                class="card-img-top"
              />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Octa - Tech for life
                </h4>
                <p class="lead text-italic text-white">
                  Doanh nghiệp cung cấp dịch vụ trung gian thanh toán và thương
                  mại điện tử quy mô lớn nhất Việt Nam
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <div class="d-flex align-items-center">
                <icon
                  name="ni ni-active-40"
                  size="lg"
                  type="warning"
                  rounded
                  class="mb-4 icon_home_page"
                ></icon>
                <h3 class="text-warning text-uppercase title_home_page">
                  Lịch sử phát triển
                </h3>
              </div>

              <p>
                CÔNG TY CỔ PHẦN DỊCH VỤ TRỰC TUYẾN ỐC TA (OCTA JSC) được thành
                lập theo Đăng ký KD số: 0108313142 do Sở KH & ĐT thành phố Hà
                Nội cấp ngày 06 tháng 06 năm 2018. Mặc dù được thành lập chưa
                lâu, nhưng với các tiềm lực sẵn có, OCTA đã nỗ lực phát triển
                không ngừng và từng bước khẳng định được vị trí dẫn đầu trên thị
                trường phân phối các sản phẩm, dịch vụ viễn thông của các nhà
                mạng tại Việt Nam. Với chiến lược đầu tư nghiên cứu công nghệ
                cao và liên tục phát triển giải pháp mới, mở rộng lĩnh vực hoạt
                động dựa trên thế mạnh sẵn có, Công ty đã định hướng hệ thống
                của OCTA là mạng thanh toán tiên phong tại thị trường Việt Nam,
                xây dựng mô hình Cổng thanh toán dịch vụ trực tuyến, thông qua
                Hệ thống thanh toán kết nối với các Ngân hàng và các nhà cung
                cấp dịch được kết nối với nhau tạo ra mạng lưới thanh toán rộng
                khắp cả nước.
              </p>
              <a href="#" class="font-weight-bold text-warning mt-5"
                >Octa - Tech for life</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-warning shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-building"
                    size="lg"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="text-success">Tầm nhìn</h5>
                  <p>
                    Đến năm 2020 nằm trong top 05 các doanh nghiệp phân phối
                    hàng đầu cung cấp các sản phẩm và dịch vụ viễn thông của tất
                    cả các đơn vị viễn thông trên toàn quốc.
                  </p>
                  <!--<a href="#" class="text-success">Learn more</a>-->
                </div>
              </div>
            </card>
            <!--<div ">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">Tầm nhìn</h4>
                                <p class="text-white">Đến năm 2020 nằm trong top 05 các doanh nghiệp phân phối hàng đầu cung cấp các sản phẩm và dịch vụ viễn thông của tất cả các đơn vị viễn thông trên toàn quốc.</p>
                            </div>
                        </div>
                        -->
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-satisfied"
                    size="lg"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="text-success">Sứ mệnh</h5>
                  <p>
                    Không ngừng đổi mới, chuyên nghiệp hóa hệ thống quản trị;
                    thúc đẩy đầu tư một cách toàn diện cho hệ thống kỹ thuật,
                    nhằm phát triển, cung cấp các sản phẩm – dịch vụ chất lượng
                    cao, mang lại những giá trị tốt nhất cho khách hàng. Từ đó
                    xây dựng lòng tin, mối quan hệ gắn bó với khách hàng và đối
                    tác để đi lên bền vững.
                  </p>
                  <!--<a href="#" class="text-success">Learn more</a>-->
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-active-40"
                    size="lg"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="text-success">Giá trị cốt lõi</h5>
                  <p>
                    Con người sáng tạo.<br />
                    Công nghệ đột phá.<br />
                    Giải pháp toàn diện.<br />
                    Dịch vụ chuyên nghiệp.<br />
                    Giá cả cạnh tranh.
                  </p>
                  <!--<a href="#" class="text-warning">Learn more</a>-->
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Ý kiến khách hàng</h2>
          </div>
        </div>
        <div class="container slider" id="slider-show">
          <div
            class="row opinion"
            v-for="item in items"
            :key="item.id"
            style="display:none"
            v-bind:class="{ active: item.id == ShowID % items.length }"
            v-bind:id="'slider-show-' + item.id"
          >
            <img v-lazy="item.image" />

            <h5 class="title">
              <span class="d-block mb-1 opinion">{{ item.title }}</span>
              <small class="h6 text-muted opinion">{{ item.message }}</small>
            </h5>
          </div>
          <div class="row paging">
            <span
              v-for="item in items"
              :key="item.id"
              v-on:click="ShowID = item.id"
              v-bind:class="{ active: item.id == ShowID % items.length }"
              v-bind:id="'slider-show-li-' + item.id"
            ></span>
          </div>
          <button class="arrow prev">
            <i
              class="fa fa-chevron-left"
              v-on:click="ShowID = prev(ShowID, items)"
            ></i>
          </button>
          <button class="arrow next">
            <i
              class="fa fa-chevron-right"
              v-on:click="ShowID = next(ShowID, items)"
            ></i>
          </button>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-0">
      <div class="container">
        <card gradient="warning" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-8">
                <h3 class="text-white">Tổ chức bộ máy</h3>
                <p class="lead text-white mt-3">
                  Công ty cổ phần trực tuyến Octa là công ty trẻ, năng động. Đội
                  ngũ nhân viên năng động, nhiệt huyết, sáng tạo trong công việc
                  và có nhiều kinh nghiệm làm dự án công nghệ thông tin cho các
                  công ty lớn trong nước và tập đoàn nước ngoài.
                </p>
              </div>
              <div class="col-lg-3 ml-lg-auto">
                <base-button tag="a" href="#" type="white" block size="lg">
                  Chi tiết
                </base-button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">OCTA - Tech for life</h2>
            <p class="lead text-white">
              Là doanh nghiệp phân phối hàng đầu cung cấp các sản phẩm và dịch
              vụ viễn thông của tất cả các đơn vị viễn thông trên toàn quốc.
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4 center">
            <icon
              name="ni ni-settings"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
              class="icon"
            ></icon>
            <h5
              class="text-white mt-3"
              style="width: 100%; text-align: center;"
            >
              Giới thiệu
            </h5>
            <p class="text-white mt-3" style="width: 100%; text-align: center;">
              Công ty cổ phần dịch vụ trực tuyến Octa. <br />
              Holine: (+84) 2435 567 567
            </p>
          </div>
          <div class="col-lg-4 center">
            <icon
              name="ni ni-ruler-pencil"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
              class="icon"
            ></icon>
            <h5
              class="text-white mt-3"
              style="width: 100%; text-align: center;"
            >
              Trợ giúp
            </h5>
            <p class="text-white mt-3" style="width: 100%; text-align: center;">
              Hướng dẫn sử dụng. <br />
              Câu hỏi thường gặp.
            </p>
          </div>
          <div class="col-lg-4 center">
            <icon
              name="ni ni-atom"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
              class="icon"
            ></icon>
            <h5
              class="text-white mt-3"
              style="width: 100%; text-align: center;"
            >
              Truy cập đa nền tảng
            </h5>
            <p class="text-white mt-3" style="width: 100%; text-align: center;">
              Kết nối đa nền tảng, máy tính bàn với máy tính bàn, thiết bị di
              động với máy bàn, máy tính bàn với thiết bị di động và thiết bị di
              động với thiết bị di động.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Muốn làm việc với chúng tôi?</h4>
              <p class="mt-0">
                Dự án của bạn rất quan trọng đối với chúng tôi.
              </p>
              <base-input
                class="mt-5"
                alternative
                placeholder="Họ tên"
                addon-left-icon="ni ni-user-run"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Email"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Nội dung..."
                ></textarea>
              </base-input>
              <base-button type="Gửi tin" round block size="lg">
                Gửi tin
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section>

    <div class="container mt-5">
      <div>        
        <!-- popup tai chính -->
        <div>
          <b-modal
            ref="my-modal-panner"
            hide-footer
            hide-header
            class="banner-modal"
            :body-class="mybannerclass"
            dialog-class="my-dialog-class"
            @hide="hidePannerEvent()"
          >
            <div class="d-block text-center">
              <img src="..\..\public\img\brand\a16.jpg" />
              <i class="ni ni-fat-remove iconClose" @click="hidePanner()"></i>
              <b-button
                class="my-button1"
                variant="none"
                block
                @click="clickPanner()"
                ><b>Đăng ký ngay</b></b-button
              >
            </div>            
          </b-modal>
        </div>

        <!-- popup Tạo -->
        <div>
          
          <b-modal
            ref="my-modal"
            hide-footer
            hide-header
            modal-class="my-popup-class"
            @hide="hideLoginEvent()"
          >
            <form ref="form" @submit="submitRegister">
              <div class="d-block text-center">
                <!-- <img src="..\..\public\img\brand\nhập thông tin Trang web octa.png" style=" cursor: pointer;" /> -->
                <h2 style="color:white;font-family:Open Sans">
                  BẠN THÍCH CHỨNG KHOÁN
                </h2>
                <p style="color:white;font-size:13px;font-family:Open Sans">
                  TẠO TÀI KHOẢN MBS MIỄN PHÍ NGAY HÔM NAY ĐỂ HƯỞNG ƯU ĐÃI
                </p>
                <!-- <h4 class="mb-1">Bạn thích chứng khoán?</h4> -->
                <i class="ni ni-fat-remove iconClose" @click="hideLogin()"></i>
                <b-form-group label-for="name-input" invalid-feedback="Họ tên">
                  <b-form-input
                    id="name-input"
                    v-model="name"
                    placeholder="Họ và tên:"
                    addon-left-icon="ni ni-user-run"
                    required
                    autocomplete="off"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-for="phone-input"
                  invalid-feedback="Số điện thoại"
                >
                  <b-form-input
                    id="phone-input"
                    v-model="phone"
                    placeholder="Số điện thoại:"
                    addon-left-icon="ni ni-mobile-button"
                    required
                    type="number"
                    autocomplete="off"
                  ></b-form-input>
                </b-form-group>
              </div>
              <b-button
                class="my-button"
                variant="none"
                block
                @click="submitRegister"
                ><b>Mở tài khoản</b></b-button
              >
              
            </form>
          </b-modal>
        </div>
        <!-- popup hướng dẫn -->
        <div>
          <b-modal ref="my-modal-info" size="xl" hide-footer hide-header @hide="hideInfoEvent()">
            <form ref="form">
              <div class="d-block">
                <h3 class="sans">
                  Mở tài khoản trực tuyến ứng dụng giải pháp eKYC qua MBS Mobile
                  App :
                </h3>
                <!-- <h4 class="mb-1">Bạn thích chứng khoán?</h4> -->
                <p class="sans">
                  Khách hàng tải MBS Mobile App về máy điện thoại tại đây
                  <a
                    href="http://bit.ly/MBS-Mobile"
                    v-b-tooltip
                    title="Tooltip in a modal!"
                    >http://bit.ly/MBS-Mobile</a
                  >
                </p>
                <img
                  src="..\..\public\img\brand\1.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\21.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\3.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\4.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\5.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\6.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\7.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\8.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <img
                  src="..\..\public\img\brand\9.png"
                  class="img-advise"
                  style="padding-right: 5px"
                />
                <p class="sans">
                  Sau khi tài khoản giao dịch chứng khoán được kích hoạt, Quý
                  Khách có thể giao dịch chứng khoán với các dịch vụ gửi tiền,
                  giao dịch cổ phiếu, giao dịch trái phiếu, quản lý tài khoản…
                  qua tất cả các kênh giao dịch trực tuyến, tổng đài<b>
                    Contact24</b
                  >, nhân viên của Octa hoặc trực tiếp tại các sàn giao dịch.
                </p>
                <i class="ni ni-fat-remove iconClose" @click="hideInfo()"></i>
              </div>
            </form>
          </b-modal>
        </div>
        <article>
          <img
            class="sticky"
            v-if="showImage"
            src="..\..\public\img\brand\imgvideo.gif"
            style="cursor: pointer; z-index: 10;"
            @click="clickPanner()"
          />
        </article>
      </div>
    </div>
    <section>
      <div>
        <a href="https://goo.gl/maps/sEXL2nU8rv2dwafD9" target="_blank">
          <img
            src="../../public/img/brand/bando1.png"
            style="width: 100%; height: auto;"
        /></a>
      </div>
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="text-center mb-5 mt-5">
            <h5 style="color: #8898aa !important;">
              Hotline: (+84) 2435 567 567
            </h5>
            <h5 style="color: #8898aa !important;">
              Địa chỉ: Số 10, ngõ 1, phố Đỗ Quang, phường Trung Hòa, quận Cầu
              Giấy Hà Nội
            </h5>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "home",
  components: {},
  showImage: false,

  data() {
    return {
      name: "",
      phone: "",
      showImage: false,
      log: (txt) => {
        console.log(txt);
      },
      items: [
        {
          id: 0,
          image: "img/theme/Untitled-2.png",
          title: "Chị Hoài - Quản lý cửa hàng tiện lợi 24h chia sẻ",
          message:
            "Sau 1 thời gian sử dụng hệ thống bán hàng Ốc Ta chị đánh giá rất cao, rất dễ sử dụng, giao diện đẹp, đa dạng sản phẩm, rất thiện cảm cho người sử dụng, chức năng bảo mật của Ốc Ta hơn các hệ thống khác đã sử dụng trước kia cho người dùng và tôi rất an tâm và hài lòng khi sử dụng sản phẩm công ty Ốc Ta",
        },
        {
          id: 1,
          image: "img/theme/Untitled-4.png",
          title: " Anh Hùng - Quản lý đại lý chia sẻ",
          message:
            "Anh đánh giá hệ thống bán hàng của Ốc ta đa dạng sản phẩm. Anh góp ý công ty nên bổ sung thêm chức năng trong mục báo cáo của đại lý để xem rõ hơn về doanh thu, lợi nhuận, đội ngũ nhân viên hỗ trợ nhiệt tình nhanh chóng, và anh rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta",
        },
        {
          id: 2,
          image: "img/theme/Untitled-6.png",
          title:
            " Chị Thương Mễ Trì, Nam Từ Liêm, Hà Nội - Quản lý đại lý chia sẻ",
          message:
            "Hệ thống bán hàng Ốc Ta chị đánh giá giao diện hệ thống đẹp, thiện cảm, bên cạnh đó chị góp ý công ty nên tối ưu hóa một số thao tác sao chép trong quá trình giao dịch bán hàng và chị rất hài lòng khi sử dụng sản phẩm công ty",
        },
        {
          id: 3,
          image: "img/theme/Untitled-5.png",
          title:
            " Anh Hưng Yên Phúc, Phúc La, Hà Đông, Hà Nội - Quản lý đại lý chia sẻ",
          message:
            "Anh đánh giá rất cao sự nhiệt tình của nhân viên trong công ty,anh rất hứng thú về giao diện hệ thống đẹp, thiện cảm cho người sử dụng, đa dạng sản phẩm, bên cạnh đó anh góp ý công ty nên xây dựng thêm ứng dụng app để thuận tiện khi sử dụng trên điện thoại, anh rất hài lòng khi sử dụng sản phẩm công ty Ốc Ta",
        },
        {
          id: 4,
          image: "img/theme/Untitled-7.png",
          title:
            " Anh Nam ngõ 192 Lê Trọng Tấn, Hoàng Mai, Hà Nội - Quản lý của hàng game chia sẻ",
          message:
            "Sử dụng hệ thống bán hàng Ốc Ta anh đánh giá rất cao sự nhiệt tình của nhân viên trong công ty hỗ trợ anh rất nhiều trong thời gian ban đầu sử dụng hệ thống mới, anh rất hứng thú về giao diện hệ thống rất đẹp, bắt mắt, rất thiện cảm cho người sử dụng, đa dạng sản phẩm, thêm vào đó khi tôi sử dụng có thể mua được nhiều mệnh giá thẻ điện thoại, thẻ game rất nhanh, thuận tiện và không thiếu hàng hay sự cố trong quá trình giao dịch",
        },
      ],
      ShowID: 0,
      mybannerclass: ["modal-banner-class"],
      mypopupclass: ["my-popup-class"],
      mypopupclas: ["my-popup-clas"],
    };
  },
  methods: {
    next: (ShowID, items) => {
      return ShowID + 1;
    },
    prev: (ShowID, items) => {
      return ShowID - 1;
    },
    pollData() {
      const self = this;
      self.polling = setInterval(() => {
        self.next(self.ShowID++, self.items);
      }, 8000);
    },
    showModal() {
      this.$refs["my-modal"].show();
      this.showImage = false;
    },
    hideModal() {
      this.$refs["my-modal"].hide();
      this.$refs["my-modal-info"].show();
    },
    showInfo() {
      this.$refs["my-modal-info"].show();
    },
    showPanner() {
      this.$refs["my-modal-panner"].show();
    },
    hidePanner() {    
      this.$refs["my-modal-panner"].hide();
      // this.$refs['my-modal-video'].hide();
      this.showImage = true;
    },
    hidePannerEvent() {   
      this.clearData();
      this.showImage = true;
    },
    hideInfo() {
      this.$refs["my-modal-info"].hide();
      this.showImage = true;
    },
    hideInfoEvent() {
      this.clearData();
      this.showImage = true;
    },
    clickPanner() {
      this.showModal();
      this.showImage = false;
    },
    clickButton() {
      this.showInfo();
    },
    hideLogin() {   
      this.$refs["my-modal"].hide();
      this.clearData();
      this.showImage = true;
    },
    hideLoginEvent() {   
      this.clearData();
      this.showImage = true;
    },
    toggleImage() {
      this.showImage = true;
      this.$refs["my-modal-info"].hide();
    },
    showVideo() {
      this.showImage = true;
    },
    hideVideo() {
      //this.showImage = false;
    },
    clickInfo() {
      this.hideInfo();
    },
    submitRegister() {
      if (
        this.name != "" &&
        this.name != null &&
        this.phone != "" &&
        this.phone != null
      ) {
        const trelloTask = {
          name: "Tư vấn đầu tư tài chính: " + this.name + " - " + this.phone,
        };
        const instance = axios.create();
        const headers = {
          "Content-Type": "application/json",
        };

        instance.post(
          "https://finance-api.octa.vn/Api/CreateCardTrello",
          trelloTask,
          { headers }
        );

        this.hideModal();
        this.clearData();
        this.showImage = false;
      }
    },
    clearData() {
      this.name = "";
      this.phone = "";
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  created() {
    this.pollData();
  },
  mounted() {
    // this.showModal();
    this.showPanner();
    // axios
    // .get('https://api.coindesk.com/v1/bpi/currentprice.json')
    // .then(response => (this.info = response))
    // this.$refs['my-modal'].on("hidden.bs.modal", this.toggleImage)
  },
};
</script>

<style scoped>
#slider-show {
  position: relative;
}
#slider-show > div > img {
  float: left;
  padding: 0 20px;
  border-radius: 50%;
  height: 200px;
  widows: 200px;
}
#slider-show .paging {
  left: 50%;
  width: 100%;
  position: absolute;
  width: 140px;
  margin-left: -70px;
}

#slider-show .paging span {
  cursor: pointer;
  background-color: white;
  height: 16px;
  width: 16px;
  margin: 2px;
  border: 1px solid #13b079;
  border-radius: 50%;
}
#slider-show .paging span.active {
  background-color: #13b079;
  font-weight: 400;
}
.arrow {
  position: absolute;
  border-radius: 15px;
  width: 30px;
  height: 30px;
  background-color: #13b079;
  color: white;
  border-color: #13b079;
  border-width: 0px;
  cursor: pointer;
  font-size: 1em;
}
.prev {
  top: 50%;
  left: -60px;
}
.next {
  top: 50%;
  right: -60px;
}

.active {
  display: block !important;
}
.title {
  max-height: 200px;
  min-height: 200px;
  overflow: hidden;
  text-align: justify;
}
.section2-func {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
}
.title_home_page {
  padding-left: 15px;
  font-weight: 600;
  font-size: 22px;
}
.center {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}
.icon {
  display: block;
  text-align: center;
  line-height: 55px;
}
@media (max-width: 768px) {
  /* .opinion{
            width: 100%!important;
        } */
  #slider-show > div > img {
    float: inherit;
    width: 100%;
    margin-bottom: 30px;
  }
}
#show-btn {
  display: none;
}
::v-deep .banner-modal > div > div > div > div > div {
  padding: 0 !important;
}

::v-deep .modal-xl {
  max-width: 1140px;
}

@media (min-width: 250px) {
  .modal-banner-class > div {
    position: fixed;
    top: 15%;
  }

  ::v-deep .modal-dialog {
    top: 15%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 260px;
  }
}

@media (min-width: 300px) {
  .modal-banner-class > div {
    position: fixed;
    top: 15%;
  }

  ::v-deep .modal-dialog {
    top: 15%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 300px;
  }
}

@media (min-width: 350px) {
  .modal-banner-class > div {
    position: fixed;
    top: 15%;
  }

  ::v-deep .modal-dialog {
    top: 15%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 345px;
  }
}

@media (min-width: 375px) {
  .modal-banner-class > div {
    position: fixed;
    top: 15%;
  }

  ::v-deep .modal-dialog {
    top: 15%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 355px;
  }
}

@media (min-width: 400px) {
  .modal-banner-class > div {
    position: fixed;
    top: 15%;
  }

  ::v-deep .modal-dialog {
    top: 15%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -15px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 395px;
  }
}

@media (min-width: 500px) {
  .modal-banner-class > div {
    position: fixed;
    top: 3%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -15px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 515px;
  }
}

@media (min-width: 700px) {
  .modal-banner-class > div {
    position: fixed;
    top: 3%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 750px;
  }

  ::v-deep .banner-modal > div > div > div {
    min-width: 810px !important;
    min-height: 450px !important;
  }
}

@media (min-width: 800px) {
  .modal-banner-class > div {
    position: fixed;
    top: 3%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-banner-class > div > img {
    width: 815px;
  }

  ::v-deep .banner-modal > div > div > div {
    min-width: 810px !important;
    min-height: 450px !important;
  }
}
@media (min-width: 800px) {
  .modal-popup-clas > div {
    position: fixed;
    top: 3%;
  }

  .iconClose {
    color: red;
    font-size: 40px;
    position: absolute;
    display: block;
    top: -20px;
    right: -20px;
    cursor: pointer;
  }

  .modal-popup-clas > div > img {
    width: 815px;
  }

  ::v-deep .my-popup-clas > div > div {
    /* background-image: url('..\..\public\img\brand\nhap-thong-tin.png'); */
    background-image: url("../../public/img/brand/a16.jpg");
    background-size: cover;
    width: 180%;
    height: 500px;
    margin-left: -40%;
    /* background-color: red; */
  }
}

::v-deep .my-popup-class > div > div {
  /* background-image: url('..\..\public\img\brand\nhap-thong-tin.png'); */
  background-image: url("../../public/img/brand/1155.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 90%;
  font-family: Open Sans;
  /* background-color: red; */
}
.padding {
  padding-left: 30px;
  padding-right: 30px;
}
.my-button {
  border: 8px solid rgb(83, 121, 148);
  background-color: rgb(166, 225, 216);
  color: black;
  font-size: 25px;
  width: 250px;
  height: 50px;
  text-align: center;
  margin-left: 25%;
  padding-top: 5px;
  font-family: Open Sans;
}
::v-deep .my-popup-clas > div > div {
  /* background-image: url('..\..\public\img\brand\nhap-thong-tin.png'); */
  background-image: url("../../public/img/brand/a16.jpg");
  background-size: cover;
  width: 180%;
  height: 500px;
  margin-left: -40%;
  /* background-color: red; */
}
.my-button1 {
  border: 12px solid rgb(83, 121, 148);
  background-color: rgb(166, 225, 216);
  color: black;
  font-size: 28px;
  width: 40%;
  height: 50px;
  text-align: center;
  vertical-align: revert;
  margin-left: 50%;
  margin-top: -15%;
  padding-top: 0.1px;
  padding-left: 2px;
  font-family: Open Sans;
}
input[type="text"] {
  background-color: rgb(83, 121, 148);
  color: black;
}
input[type="number"] {
  background-color: rgb(83, 121, 148);
  color: black;
}
input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: black;
  opacity: 1; /* Firefox */
}
.video-class {
  top: 80%;
  left: -90%;
}
.img-advise {
  width: 350px;
  padding-top: 5px;
}

.sticky {
  position: fixed;
  bottom: 0;
  left: 0;
  /* height: 30%; */
  width: 15%;
  background-color: white;
}

@media (max-width: 414px) {
  .my-button {
    padding-top: 2px;
  }
  ::v-deep .my-popup-class > div > div {
    /* background-image: url('..\..\public\img\brand\nhap-thong-tin.png'); */
    background-image: url("../../public/img/brand/1157.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 90%;
    /* background-color: red; */
  }
}

@media (max-width: 280px) {
  .form-group > div > input {
    height: 25px;
  }

  ::v-deep .my-button {
    height: 45px;
  }

  ::v-deep .my-button > h4 {
    font-size: 1rem;
  }
  .my-button1 {
    padding-left: 7px;
  }
}

@media (max-width: 653px) {
  .img-advise {
    width: 90%;
  }

  .my-button {
    width: 90%;
    margin-left: 5%;
  }

  .my-button1 {
    width: 40%;
    height: 40px;
    margin-left: 40%;
    margin-top: -20%;
    font-size: 8px;
    border: 6px solid rgb(83, 121, 148);
    padding-top: 3px;
    font-size: 10px;
  }
}

@media (max-width: 912px) {
  .sticky {
    position: fixed;
    bottom: 0;
    left: 0;
    /* height: 30%; */
    width: 30%;
    background-color: white;
  }
}

@media only screen and (min-width: 768px) {
  .img-advise {
    width: 350px;
  }

  .my-button {
    width: 250px;
    height: 60px;
    padding-top: 8px;
  }

  .my-button1 {
    width: 250px;
    height: 60px;
  }
}

.sans {
  font-family: Open Sans;
}
</style>
